<template>
    <section class="registration-form">
        <div class="container">
            <validation-observer v-if="!success" ref="registrationForm">
                <div class="row mb-5">
                    <div class="col-12">
                        <h2>Activeer jouw account</h2>
                    </div>
                </div>
                <form v-if="!processing">
                    <div class="row mb-4">
                        <div class="col-12">
                            <h3>Vul hier jouw nieuwe wachtwoord in</h3>
                        </div>
                        <text-input
                            v-model="form.password1"
                            class="col-12 col-sm-6"
                            name="Wachtwoord"
                            rules="required"
                            type="password"
                            placeholder=""
                        />
                    </div>
                    <div class="row mb-4">
                        <text-input
                            v-model="form.password2"
                            class="col-12 col-sm-6 mb-2"
                            name="Herhaal jouw wachtwoord"
                            rules="required"
                            placeholder=""
                            type="password"
                        />
                    </div>
                    <div class="row mb-4">
                        <button
                            type="button"
                            class="btn"
                            @click="activateAccount"
                        >
                            <span>Activeer account!</span>
                        </button>
                    </div>
                </form>
                <form v-else>
                    <span>Een moment geduld...</span>
                </form>
            </validation-observer>
            <div v-if="!success && notification != ''">
                <div v-html="notification"></div>
            </div>
            <div v-if="success">
                <span v-html="successText"></span>
                <p>
                    Je kan inloggen via
                    <a href="https://verwonderomdehoek.nl/umbraco"
                        >verwonderomdehoek.nl/umbraco</a
                    >
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';

import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        intro: {
            type: String,
            default: ''
        },
        successText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            errorMessage: '',
            form: {
                password1: '',
                password2: ''
            },
            guid: '',
            token: '',
            success: false,
            notification: '',
            url: '/api/registration/activateuser',
            processing: false
        };
    },
    mounted() {
        if (this.$route.query.guid) {
            this.guid = this.$route.query.guid;
        }

        if (this.$route.query.token) {
            this.token = this.$route.query.token;
        }
    },
    methods: {
        activateAccount() {
            this.notification = '';
            this.success = false;

            if (this.password1 != this.password2) {
                this.notification =
                    'De opgegeven wachtwoorden zijn niet aan elkaar gelijk.';
                return;
            }
            this.processing = true;
            Axios({
                method: 'post',
                url: this.url,
                data: {
                    password1: this.form.password1,
                    password2: this.form.password2,
                    guid: this.guid,
                    token: this.token
                }
            })
                .then(response => {
                    const result = response.data;
                    this.success = result.Success;
                    if (this.success) {
                        this.notification = result.SuccessMsg;
                    } else {
                        this.notification = result.ErrorMsg;
                    }
                })
                .catch(error => {
                    this.notification = error;
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
};
</script>

<style lang="scss">
.input-error {
    color: $red;
}
</style>
